/**
 * Given two dates, it calculates the difference between them and returns an object with
 * the difference in days, hours, minutes and seconds
 * @param date1 - First date
 * @param date2 - Second date
 * @returns the difference object containing days, hours, minutes and seconds
 */
export const dateDiff = (date1, date2) => {
  const dateDiffInMs = +date1 - +date2;
  const days = Math.floor(dateDiffInMs / (24 * 3600 * 1000));
  let rest = dateDiffInMs % (24 * 3600 * 1000);
  const hours = Math.floor(rest / (3600 * 1000));
  rest = rest % (3600 * 1000);
  const minutes = Math.floor(rest / (60 * 1000));
  rest = rest % (60 * 1000);
  const seconds = Math.floor(rest / 1000);

  return {
    days,
    hours,
    minutes,
    seconds,
  };
};
